import { communityMemberAdded } from "./communityMemberAdded";
import { communityMemberRemoved } from "./communityMemberRemoved";

export const communityMemberAddedToAccessGroup = communityMemberAdded;
export const communityMemberRemovedFromAccessGroup = communityMemberRemoved;
